module.exports = __webpack_public_path__ + "static/main-photo-9954d14e39fd32412db6f2d5abc37663.jpg";